<template>
    <div id="trigger-menu" :class="[
        shit$(`px:10px; py:10px; pt:10px;`),
        shit$(`@xl:px:20px; @xl:pt:25px;`)
    ]">
        <section class="top" v-show="isTouch">
            <div class="backClass">
                <span @click="back">
                    <span>&lt;</span> 
                    {{$t("kebbi")}}{{ isTouch ? $t(isTouch['name']) : "" }}
                </span>
            </div>
            <section class="listen"  style="margin-top: 30px;" v-if="isTouch['key'] === 'listen'">
                <section class="listenText">
                    <el-input
                        :resize="'none'"
                        type="textarea"
                        :maxlength="20"
                        :placeholder="$t('placeholder.robot_hear')"
                        v-model="listen['textarea']">
                    </el-input>
                    <div style="text-align: right; margin-top: 15px; color: #fff;">({{ listen['textarea'].length }}/20 )</div>
                </section>
                <div class="listenButton">
                    <el-button @click="listenAction(listen['textarea'])">{{$t("button.ok")}}</el-button>
                </div>
            </section>

            <section class="see" v-else-if="isTouch['key'] === 'see'">
                <el-checkbox-group v-model="seeTarget" @change="onSeeTargetChange">
                    <div>
                        <el-checkbox label="family" :disabled="seeTarget.includes('family')"></el-checkbox>
                        <el-select 
                        ref="addFamilies"
                        class="select-familier"
                        popper-class="select-familier-dropdown"
                        v-model="familyValue"
                        :placeholder="$t('placeholder.select_see_familier')"
                        :disabled="!seeTarget.includes('family')"
                        >
                            <el-option
                            v-for="item in seeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            <el-option
                            v-if="seeOptions.length === 0"
                            :label="$t('placeholder.no_families')"
                            value="nuwa-add-families"
                            class="add-family-item"
                            >
                            <p class="add-family-btn" @click.stop="addFamilies">{{$t('placeholder.no_families')}}</p>
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        <el-checkbox label="aiObject" :disabled="seeTarget.includes('aiObject')"></el-checkbox>
                        <el-autocomplete
                        :disabled="!seeTarget.includes('aiObject')"
                        v-model="recognizeLabel"
                        class="select-familier"
                        value-key="label"
                        popper-class="el-dropdown-menu select-familier-dropdown"
                        :fetch-suggestions="getAiObjectsByKeyword"
                        :placeholder="$t('placeholder.select_aiobject')"
                        :select-when-unmatched="true"
                        ></el-autocomplete>
                    </div>
                </el-checkbox-group>
                <el-button v-if="seeTarget[0] === 'family'" class="confirmListen" :disabled="!familyValue" @click="seeFamily">{{$t("button.ok")}}</el-button>
                <el-button v-else-if="seeTarget[0] === 'aiObject'" class="confirmListen" :disabled="!recognizeLabel" @click="recognizeAction">{{$t("button.ok")}}</el-button>
            </section>
        </section>
            <section ref="getRoudReact" v-show="!isTouch" :class="[ 'bottom' ]">
                <template  v-for="(item, index) in views['buttons']" >
                    <template>
                        <p
                            :class="[shit$(`w:25%;`), ]"
                            :key="index">
                            <el-button
                                @mouseenter.native="mouseenterNative(item, index)"
                                @mouseleave.native="mouseleaveNative(item, index)"
                                circle
                                @click="touchAction({ ...item, index })"
                                class="button">
                                <img :src="`${item.href}${item.is ? '-active' : ''}.png`" :class="shit$(`w:25px; h:25px;`)"/>
                                <!-- <svg-icon :href="item.svg" :width="25" :height="25"></svg-icon> -->
                            </el-button>
                            <span>{{ $t(item['name']) }}</span>
                        </p>
                    </template>
                </template>
            </section>
        <add-families v-if="showAddFamilies" :visible.sync="showAddFamilies"></add-families>
    </div>
</template>

<script>
import AddFamilies from "@/code-lab/component/popper-add-families.vue";

import { mapState, mapActions } from 'vuex';
const mpUrl = ""+ process.env.BASE_URL +"static/images/trigger/normal/"
const Cookies = window.Cookies;
export default {
    components: {
        AddFamilies,
    },
    data: () => ({
        isTouch: '',
        views: {
            buttons: [
                { is: false, name: 'touch_head', svg: "#codelab-trigger-touch-head", href: ""+ mpUrl +"codelab-trigger-touch-head", actionName: 'TouchAction,0', key: "touch" },
                { is: false, name: 'touch_belly', svg: "#codelab-trigger-touch-belly", href: ""+ mpUrl +"codelab-trigger-touch-belly", actionName: 'TouchAction,1', key: "touch" },
                { is: false, name: 'touch_right_hand', svg: '#codelab-trigger-touch-right', href: ""+ mpUrl +"codelab-trigger-touch-right", actionName: 'TouchAction,2', key: "touch" },
                { is: false, name: 'touch_left_hand', svg: '#codelab-trigger-touch-left', href: ""+ mpUrl +"codelab-trigger-touch-left", actionName: 'TouchAction,3', key: "touch" },
                { is: false, name: 'code-lab/component/management-programming/trigger/trigger-component.vue_7', svg: '#codelab-trigger-see', href: ""+ mpUrl +"codelab-trigger-see", key: 'see' },
                { is: false, name: 'hear_something', svg: '#codelab-trigger-listen', href: ""+ mpUrl +"codelab-trigger-listen", key: 'listen' },
                { is: false, name: 'touch_right_cheek', svg: '#codelab-trigger-touch-right', href: ""+ mpUrl +"codelab-trigger-touch-right-cheek", actionName: 'TouchAction,5', key: "touch" },
                { is: false, name: 'touch_left_cheek', svg: '#codelab-trigger-touch-left', href: ""+ mpUrl +"codelab-trigger-touch-left-cheek", actionName: 'TouchAction,4', key: "touch" },
            ]
        },
        seeTarget: ['family'],//看到的目标，family-家人，aiObject-物品
        familyValue: "",
        listen: {
            textarea: '',
            button: false
        },
        recognizeLabel: '',
        resizeTimer: null,
        showAddFamilies: false,
        tempAiObjects: []
    }),
    computed: {
        ...mapState('user', [
            'teamId',
            'token'
        ]),
        ...mapState({
            robotFamilies: "robotFamilies",
            tempFamilies: "tempFamilies",
            env$: 'env$',
            ttsLangCode: "ttsLangCode",
            usedFamilies: "usedFamilies",
            connectGolbalState: 'connectGolbalState'
        }),
        ...mapState("introStore", {
            showBox: "showBox"
        }),
        seeOptions () {
            let families;
            let usedFamilies = this.usedFamilies
            if(this.connectGolbalState === 2){
                //快速連線
                usedFamilies = usedFamilies.filter(item => !this.robotFamilies.some(family => family.value === item.value))
                families = [...this.robotFamilies, ...usedFamilies]
            } else {
                usedFamilies = usedFamilies.filter(item => !this.tempFamilies.some(family => family.value === item.value))
                families = [...this.tempFamilies, ...usedFamilies]
            }
            return families.map(item => {
                return {
                    value: item.value,
                    label: item.label || this.$t('unname_nickname')
                }
            });
        }
    },
    watch: {
        isTouch () {
            this.onResize();
        },
        showBox(value){
            if(value && this.isTouch){
                this.back();
            }
        }
    },
    mounted () {
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize)
            const langCode = Cookies.get("langCode");
            this.$store.commit('introStore/updSimulatorDB', [
                {
                    stack: [
                        { index: 1, md: 'right', target: this.$refs.getRoudReact, position: 'right', type: 'rect_', clientH: 500, clientW: 400, offsetRct: 0, data: {
                            header_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_0"),
                            header_t2: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_1"),
                            img: `${this.env$}static/images/intro/${langCode}/intro_2.png`,
                            content_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_2"),
                            btn_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_3"),
                            btn_t_1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_4"),
                            btn_t1_shit: 'bottom:30px!;'
                        } },
                        { index: 2, fn: indx => indx < 4, md: 'right', target: this.$refs.getRoudReact, position: 'right', type: 'rect_', clientH: 500, clientW: 400, offsetRct: 0, data: {
                            header_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_5"),
                            header_t2: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_6"),
                            img: `${this.env$}static/images/intro/${langCode}/intro_3.png`,
                            content_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_7"),
                            btn_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_8"),
                            btn_t_1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_9"),
                            btn_t1_shit: 'bottom:30px!;'
                        } },
                        { index: 3, fn: indx => indx === 4, md: 'right', target: this.$refs.getRoudReact, position: 'right', type: 'circle_', clientH: 500, clientW: 400, offsetRct: 0, data: {
                            header_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_10"),
                            header_t2: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_11"),
                            img: `${this.env$}static/images/intro/${langCode}/intro_4.png`,
                            content_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_12"),
                            btn_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_13"),
                            btn_t_1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_14"),
                            btn_t1_shit: 'bottom:30px!;'
                         }  },
                        { index: 4, fn: indx => indx === 5, md: 'right', target: this.$refs.getRoudReact, position: 'right', type: 'circle_', clientH: 500, clientW: 400, offsetRct: 0, data: {
                            header_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_15"),
                            header_t2: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_16"),
                            img: `${this.env$}static/images/intro/${langCode}/intro_5.png`,
                            content_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_17"),
                            btn_t1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_18"),
                            btn_t_1: this.$t("code-lab/component/machine-simulator/trigger-menu.vue_19"),
                            btn_t1_shit: 'bottom:30px!;'
                        }  }
                    ]
                }
            ])
        })
    },
    methods: {
        ...mapActions('introStore', ['excuteStackSimulator_']),
        mouseenterNative (item) {
            item.is = true
        },
        mouseleaveNative (item) {
            item.is = false
        },
        touchAction (item) {
            this.isTouch = item['key'] !== "touch" ? item : '';
            if(!this.isTouch){
                this.$emit('kibieEmit', item);
            }
        },
        listenAction(text){
            this.$emit('kibieEmit', Object.assign(this.views.buttons[5],{
                actionName: 'ListenAction,' + text,
                content: text
            }));
        },
        back () {
            this.isTouch = ''
            this.$emit('kibieEmit', '')
        },
        onSeeTargetChange(value){
            this.seeTarget = value.slice(-1)
        },
        seeFamily () {
            let label = this.seeOptions.find(item => item.value === this.familyValue);
            label = label ? label.label : "";
            this.$emit('kibieEmit', {
                name: "see_someone",
                key: "see",
                actionName: "MCFaceRecognitionAction," + this.familyValue,
                label
            })
        },
        getAiObjectsByKeyword(keyword, callback){
            if(!keyword || !keyword.trim()){
                return callback([])
            }
            let query = {
                 customerId: this.teamId, 
                 type: "aiObject", 
                 limit: 20, 
                 page: 1,
                 keyword
            };
            this.http$('get', '/developTool/materials', query, null, {
                Authorization: "Bearer " + this.token
            }).then(res => {
                console.log("get ai materials:", res)
                if(res.data && res.data.status && res.data.status.code === "0" && res.data.data){
                    const payload = res.data.data.payload || []
                    const data = payload.map(item => {
                        return Object.assign(item, {label: (this.util$.getI18nLabel$(item.metadata.i18n, 'langCode', 'name') || item.metadata.title)})
                    })
                    callback(data);
                    this.tempAiObjects = data;
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error("get ai materials error:", err);
                callback([]);
            })
        },
        recognizeAction(){
            let data = this.tempAiObjects.find(item => item.label === this.recognizeLabel)
            let msg = {
                name: "recognize_something",
                key: "recognize",
                label: this.recognizeLabel,
                data
            };
            if(data){
                msg.actionName = "RecognizeAction," + data.metadata.itemId;
            } else {
                msg.actionName = "RecognizeAction," + this.recognizeLabel;
            }
            this.$emit('kibieEmit', msg)
            console.log("recognize:",msg)
        },
        addFamilies(){
            if (this.robotFamilies && this.robotFamilies.length > 0) {
                this.$message({
                    message: this.$t("message.warn_add_families"),
                    duration: 5000
                });
                return;
            }
            this.$refs.addFamilies && (this.$refs.addFamilies.visible = false);
            this.showAddFamilies = true;
        },
        onResize () {
            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = null;
            }
            this.resizeTimer = setTimeout(() => {
                if(this.$refs.scrollBar){
                    this.$refs.scrollBar.update();
                    this.$refs.scrollBar.$el.querySelector(".el-scrollbar__wrap").scrollTop = 0;
                }
            }, 200);
        }
    }
}
</script>

<style lang="scss">
#trigger-menu {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    text-align: center;
    .el-scrollbar{
        width: 100%;
        height: 100%;
        overflow: hidden;
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
    .top {
        
        padding: 10px 0px 0px 0px;
        width: 100%;
        height: 100%;
        background-color: #272727;
        overflow-y: auto;
        .backClass {
            color: #ffffff;
            transition: .4s;
            text-align: left;
        }
        .listen {
            .listenText {
                padding-right: 30px;
                padding-left: 15px;
                .el-textarea__inner {
                    letter-spacing: 1.5px;
                    padding: 10px 15px;
                    background: transparent;
                    color: #ffffff;
                }
            }
            .listenButton {
                text-align: right;
                margin-top: 10px;
                button {
                    border-radius: 15px;
                    margin-top: 20px;
                    margin-right: 10px;
                    background: transparent;
                }
            }
        }
        .see {
            width: 100%;
            padding: 20px 12px ;
            text-align: left;
            .el-checkbox-group{
                &>div{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 12px;
                    .el-checkbox{
                        flex: 0 0 auto;
                        margin-right: 12px;
                        .el-checkbox__label{
                            display: none;
                        }
                        .el-checkbox__inner{
                            background: transparent;
                        }
                    }
                    .el-select,.el-autocomplete{
                        flex: 1 1 auto;
                        .el-input.is-disabled{
                            .el-input__inner{
                                border-color: #363131;
                                opacity: 0.8;
                            }
                        }
                    }
                }
            }
            .select-familier{
                &.el-select, &.el-autocomplete{
                    width: 200px;
                    .el-input .el-input__inner{
                        border-width: 1px;
                        background: $--codelab-primary-black-1;
                    }
                    .el-input.is-focus .el-input__inner,.el-input:focus .el-input__inner{
                        border-color: $--codelab-primary-gray-2;
                        color: $--codelab-primary-blue-1;
                    }
                }
            }
            .confirmListen {
                float: right;
                border-radius: 15px;
                margin-top: 25px;
                background: transparent;
            }
        }
    }
    .bottom {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .button {
            margin: 0px;
            margin-bottom: 8px;
            margin-right: 10px;
            padding: 9px 10px;
            &:active {
                opacity: .7;
            }
        }
        .el-button {
            border: none;
            background: #333333;
            svg{
                fill: #8c8c8c;
            }
            &:hover,&:active{
                svg{
                    fill: #1ACDF7;
                }
            }
        }
        p {
            display: flex;
            font-size: 12px;
            flex-direction: column;
            align-items: center;
            margin: 10px 0px;
            color: #ffffff;
        }
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #00a5fe;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        border-color: #00a5fe;
        background: transparent;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
        background: transparent;
        border-color: rgb(168, 168, 172);
    }
    .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        height: 6px;
        left: 5px;
        width: 3px;
        border-width: 0px 2px 2px 0px;
        border-radius: 1px;
    }
    .el-checkbox__inner {
        width: 16px;
        height: 15px;
    }
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #1ac9f5;
}
.el-select-dropdown__item.hover {
    background: transparent;
    
}
.el-select-dropdown__item:hover {
    background: #444444;
    color: $--codelab-primary-blue-1;
}
.el-select-dropdown__item.selected {
    color: $--codelab-primary-blue-1;
    font-weight: normal;
}



.el-select-dropdown__list {
    background: #272727;
}
.el-select-dropdown {
    border-color: #333; 
    .el-scrollbar{
        border-radius: 8px;
    }
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
    background: transparent;
    border-bottom-color: #272727;
}
.el-popper[x-placement^=top] .popper__arrow::after{
    background: transparent;
    border-top-color: #272727;
}
.el-select-dropdown.select-familier-dropdown{
    width: 200px;
    background: $--codelab-primary-black-1;
    .el-select-dropdown__item.selected:after {
        position: absolute;
        right: 20px;
        font-family: element-icons;
        content: "\e6da";
        font-size: 12px;
        font-weight: 700;
    }
}
.el-select-dropdown__item.add-family-item{
    padding: 0;
    .add-family-btn{
        padding: 0 20px;
        text-align: left;
        .svg-icon{
            margin-right: 6px;
        }
        &:hover{
            .svg-icon{
                fill: #1ACDF7;
            }
        }
    }
}

</style>
